<div fxLayout="column" fxFill>
  <mat-toolbar>
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <div class="heading" fxLayout="row" fxLayoutAlign="start center">
        <button mat-button [routerLink]="['../../']">
          <mat-icon>keyboard_backspace</mat-icon>
        </button>
        <mat-divider [vertical]="true"></mat-divider>
        <span>{{ (constructionSite$ | async).name }}</span>
      </div>
      <div class="date" fxLayoutAlign="start center">
        <button mat-button (click)="viewPreviousMonth()">
          <mat-icon class="material-icons">keyboard_arrow_left</mat-icon>
        </button>
        <span>{{ date$ | async | date : 'MMMM yyyy' }}</span>
        <button mat-button (click)="viewNextMonth()">
          <mat-icon class="material-icons">keyboard_arrow_right</mat-icon>
        </button>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <app-tour-list [tours]="tours$ | async" mode="monthOverview" class="main-content" fxFlex="grow"></app-tour-list>

  @if (actionPending$ | async) {
    <div class="spinner-container">
      <mat-spinner></mat-spinner>
    </div>
  }
</div>
